module.exports = __webpack_public_path__ + "img/zjdx_logo@2x.0415c375.png";